module.exports = __webpack_public_path__ + "media/stylesheets/indieflower400-688b17a6085afe8f07f4f3197610081b.woff2";